import { SimplePlaceholder } from '@components'
import { Button } from '@heroui/react'
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'

const StatsNotReadyPlaceholder = ({ handleRefetch, isRefetching }) => (
  <SimplePlaceholder 
    title="Loading Delivery Stats" 
    icon={QuestionMarkCircleIcon}
  >
    <p className='mb-4'>This batch of emails is currently in the queue to be processed.</p> 
    <p className='mb-4'>Please wait 1 minute and then click the refresh button below to check if processing is complete.</p>
    
    <Button color="secondary" size="lg" fullWidth onPress={() => handleRefetch()} isLoading={isRefetching}>
      Refresh
    </Button>
  </SimplePlaceholder>
)

StatsNotReadyPlaceholder.propTypes = {
  handleRefetch: PropTypes.func.isRequired,
  isRefetching: PropTypes.bool.isRequired,
}

export default StatsNotReadyPlaceholder